import React, { Fragment, Component } from "react";
import { get as _get, isEmpty as _isEmpty, map as _map, forEach as _forEach, cloneDeep as _cloneDeep, reject as _reject } from "lodash";
import { Tooltip, OverlayTrigger, Accordion, Card } from "react-bootstrap";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { FormattedMessage, injectIntl } from "react-intl";
import { connect } from "react-redux";

import { showAlertMessage, CustomModal } from "../../formElements";
import { withRouter } from "../../../hoc/withRouter";

import { thousandSeparator } from "../../../../helpers/utils";

import { updatePageOperationLevelLoadingState } from "../../../../redux/actions/application";
import { initiateEnrichSearch } from "../../../../redux/services/enrich";

class EnrichDataSources extends Component {

  constructor(props) {
    super(props);

    this.appendOptionList = [
      { id: "add", name: "Add", isDisabled: false },
      // { id: "replace", name: "Replace", isDisabled: true },
      // { id: "fill", name: "Fill Blanks", isDisabled: true },
    ];

    this.defaultState = {
      activeRequestCount: 0,
      selectedAppendOption: "add",
      defaultSearch: "contact",
      selectedSourcefield: [],
      allSelectedSourcefield: [],

      // Success confirmation box
      showEnrichSuccessConfirmationBox: false
    }

    this.state = {
      ...this.defaultState
    };
  }

  _incrementLoader = () => {
    const { updatePageOperationLevelLoadingState } = this.props;
    this.setState((prevState) => {
      const nextCount = (_get(prevState, "activeRequestCount", 0) + 1);
      if (nextCount === 1 && typeof updatePageOperationLevelLoadingState === "function") { updatePageOperationLevelLoadingState(true); }
      return { activeRequestCount: nextCount };
    });
  }

  _decrementLoader = () => {
    const { updatePageOperationLevelLoadingState } = this.props;
    this.setState((prevState) => {
      const nextCount = Math.max(0, _get(prevState, "activeRequestCount", 0) - 1);
      if (nextCount === 0 && typeof updatePageOperationLevelLoadingState === "function") { updatePageOperationLevelLoadingState(false); }
      return { activeRequestCount: nextCount };
    });
  }

  _handleDataFieldSelection = (checked, dataSourceId, dataFieldId, selectedField, groupName) => {
    const { dataSourceList } = this.props;
    const { selectedSourcefield, allSelectedSourcefield, defaultSearch } = this.state;

    let tmpSelectedSourcefield = _cloneDeep(selectedSourcefield || []);
    let tmpAllSelectedSourcefield = _cloneDeep(allSelectedSourcefield || []);
    let tmpDataSource = _cloneDeep(dataSourceList || []);

    if (checked) {
      let prioritySequence = tmpAllSelectedSourcefield.length + 1;
      // If First Time Select field of related source,  Add Source Array and it's selected field
      if (!tmpAllSelectedSourcefield.includes(dataSourceId)) {
        tmpAllSelectedSourcefield.push(dataSourceId);

        let fieldValue = 0;
        let fieldType = 0;

        if (defaultSearch === "contact") {
          (selectedField.field_types || []).forEach(element => {

            if (((groupName || "contact") === "common") && ((element.field_type_id || 0) === 1)) { // if field type 1 == contact
              fieldValue = (element.data_field_id || 0);
              fieldType = (element.field_type_id || 0);
            } else if ((groupName || "contact") !== "common") {
              fieldValue = (element.data_field_id || 0);
              fieldType = (element.field_type_id || 0);
            }
          });
        }

        if (defaultSearch === "company") {
          (selectedField.field_types || []).forEach(element => {
            if (((groupName || "contact") === "common") && ((element.field_type_id || 0) === 2)) { // if field type 2 == Company
              fieldValue = (element.data_field_id || 0);
              fieldType = (element.field_type_id || 0);
            } else if ((groupName || "contact") === "company") {
              fieldValue = (element.data_field_id || 0);
              fieldType = (element.field_type_id || 0);
            }
          });
        }

        tmpSelectedSourcefield.push({
          "data_source_id": dataSourceId,
          "priority_sequence": prioritySequence,
          "data_fields": [{
            "data_field_id": (fieldValue || null),
            "data_field_type": (fieldType || 0),
          }]
        });
      } else {  // If related data source already added then add datafield to its array
        tmpDataSource.map((selectedSource) => {

          if (selectedSource.id === dataSourceId) {

            tmpSelectedSourcefield.map((relatedSource) => {

              if ((relatedSource.data_source_id || 0) === dataSourceId) {

                let fieldValue = 0;
                let fieldType = 0;
                if (defaultSearch === "contact") {
                  (selectedField.field_types || []).forEach(element => {

                    if (((groupName || "contact") === "common") && ((element.field_type_id || 0) === 1)) { // if field type 1 == contact
                      fieldValue = (element.data_field_id || 0);
                      fieldType = (element.field_type_id || 0);
                    } else if ((groupName || "contact") !== "common") {
                      fieldValue = (element.data_field_id || 0);
                      fieldType = (element.field_type_id || 0);
                    }
                  });
                }

                if (defaultSearch === "company") {
                  (selectedField.field_types || []).forEach(element => {
                    if (((groupName || "contact") === "common") && ((element.field_type_id || 0) === 2)) { // if field type 2 == Company
                      fieldValue = (element.data_field_id || 0);
                      fieldType = (element.field_type_id || 0);
                    } else if ((groupName || "contact") === "company") {
                      fieldValue = (element.data_field_id || 0);
                      fieldType = (element.field_type_id || 0);
                    }
                  });
                }

                relatedSource.data_fields.push({
                  "data_field_id": (fieldValue || null),
                  "data_field_type": (fieldType || 0),
                });
              }
              return false;
            });
          }
          return false;
        });
      }
    } else {

      //if uncheck remove deselected field from data resource state for post submission
      tmpSelectedSourcefield.map((relatedSource, k) => {

        if ((relatedSource.data_source_id || 0) === dataSourceId) {

          let selectedDataFields = relatedSource.data_fields;
          selectedDataFields.map((selectedField, key) => {

            if (selectedField.data_field_id === dataFieldId) {
              selectedDataFields.splice(key, 1);
            }
            return false;
          });

          if (selectedDataFields.length === 0) {

            tmpSelectedSourcefield.splice(k, 1);

            const index = tmpAllSelectedSourcefield.indexOf(dataSourceId);
            if (index > -1) {
              tmpAllSelectedSourcefield.splice(index, 1);
            }
          }
        }
        return false;
      });
    }

    this.setState({ selectedSourcefield: tmpSelectedSourcefield, allSelectedSourcefield: tmpAllSelectedSourcefield });
  }

  _handleDataSourceSelection = (checked, value) => {
    const { dataSourceList } = this.props;
    const { selectedSourcefield, allSelectedSourcefield, defaultSearch } = this.state;

    let tmpSelectedSourcefield = _cloneDeep(selectedSourcefield || []);
    let tmpAllSelectedSourcefield = _cloneDeep(allSelectedSourcefield || []);
    let prioritySequence = 0;

    if (checked) {
      let tmpAllSubFields = [];

      dataSourceList.map((relatedSource) => {

        if (relatedSource.id === value) {
          if (!tmpAllSelectedSourcefield.includes(value)) {
            tmpAllSelectedSourcefield.push(value);
          }

          let tmpFieldGroup = relatedSource.data_field_group;

          tmpFieldGroup.map((singleGroup) => {

            let tmpFields = (singleGroup.data_fields || []);
            let tmpgroupName = (singleGroup.group_name || "contact").toLowerCase();
            let pushData = false;

            if ((defaultSearch || "contact") === "contact") {
              pushData = true;
            }

            if (((defaultSearch || "contact") === "company") && ((tmpgroupName === "company") || (tmpgroupName === "common"))) {
              pushData = true;
            }

            if ((pushData || false) === true) {
              tmpFields.map((singleField) => {

                let fieldValue = 0;
                let fieldType = 0;
                if (defaultSearch === "contact") {
                  (singleField.field_types || []).forEach(element => {

                    if ((tmpgroupName === "common") && ((element.field_type_id || 0) === 1)) { // if field type 1 == contact
                      fieldValue = (element.data_field_id || 0);
                      fieldType = (element.field_type_id || 0);
                    } else if (tmpgroupName !== "common") {
                      fieldValue = (element.data_field_id || 0);
                      fieldType = (element.field_type_id || 0);
                    }
                  });
                }

                if (defaultSearch === "company") {
                  (singleField.field_types || []).forEach(element => {

                    if ((tmpgroupName === "common") && ((element.field_type_id || 0) === 2)) { // if field type 2 == Company
                      fieldValue = (element.data_field_id || 0);
                      fieldType = (element.field_type_id || 0);
                    } else if (tmpgroupName === "company") {
                      fieldValue = (element.data_field_id || 0);
                      fieldType = (element.field_type_id || 0);
                    }
                  });
                }

                tmpAllSubFields.push({
                  "data_field_id": (fieldValue || null),
                  "data_field_type": (fieldType || 0),
                });
                return false;
              });
            }

            return false;
          });
        }
        return false;
      });

      tmpSelectedSourcefield.push({
        "data_source_id": value,
        "priority_sequence": prioritySequence,
        "data_fields": tmpAllSubFields
      });
    } else {

      tmpSelectedSourcefield.map((selectedField, key) => {

        if (selectedField.data_source_id === value) {

          tmpSelectedSourcefield.splice(key, 1);

          const index = tmpAllSelectedSourcefield.indexOf(value);
          if (index > -1) {
            tmpAllSelectedSourcefield.splice(index, 1);
          }
        }
        return false;
      });
    }

    this.setState({ selectedSourcefield: tmpSelectedSourcefield, allSelectedSourcefield: tmpAllSelectedSourcefield });
  }

  _onDataSourceDragEnd = (result) => {
    const { dataSourceList } = this.state;

    // dropped outside the list
    if (result.destination === null) {
      return;
    }

    const source = _get(result, "source.index", null);
    const destination = _get(result, "destination.index", null);

    let tmpDataSource = _cloneDeep(dataSourceList || []);

    const [removed] = tmpDataSource.splice(source, 1);
    tmpDataSource.splice(destination, 0, removed);

    tmpDataSource = _reject((tmpDataSource || []), _isEmpty);

    this.setState({ dataSourceList: tmpDataSource });
  };

  _handleSubmit = async (isCalcuateEstimation) => {
    const { fileUploaded, savedSearchId, selectedSavedSearchId } = this.props;
    const { selectedSourcefield, selectedAppendOption } = this.state;

    let isDataFieldEmpty = (selectedSourcefield || []).length > 0 ? false : true;

    if (!fileUploaded && (_get(selectedSavedSearchId, "id", null) === null)) {
      showAlertMessage("Please upload a file or select saved search.");
      return false;
    }

    if (fileUploaded && !isCalcuateEstimation && !savedSearchId) {
      showAlertMessage("Search id not saved, Please upload file and try again.");
      return false;
    }

    _forEach(selectedSourcefield, (sf, i) => {
      if (_isEmpty(sf.data_fields)) { isDataFieldEmpty = true; }
      sf.priority_sequence = i + 1;
    });

    if (isDataFieldEmpty === true) {
      showAlertMessage("Please select at least one data field.");
      return false;
    }

    try {
      this._incrementLoader();

      let payload = {
        "search_id": (fileUploaded) ? (savedSearchId || null) : _get(selectedSavedSearchId, "id", null),
        "data_sources": selectedSourcefield,
        "append_option": selectedAppendOption
      }

      const response = await initiateEnrichSearch(payload);

      if (_get(response, "flag", null) === true) {

        this.setState({ showEnrichSuccessConfirmationBox: true });
      } else {
        showAlertMessage(_get(response, "message", "Something went wrong while initiating enrich."));
      }

    } catch (error) {
      showAlertMessage(_get(error, "message", "Something went wrong while initiating enrich."));

    } finally {
      this._decrementLoader();
    }
  }

  _handleReset = () => {
    const { resetParentProps } = this.props;

    this.setState({ ...this.defaultState });

    if (typeof resetParentProps === "function") { resetParentProps(); }
  }

  _checkInArray = (value, arr) => {
    let foundIndex = false;

    _forEach(arr, (v, k) => {
      if (v.data_source_id === value) {
        foundIndex = k;
      }
    });

    return foundIndex;
  }

  _renderEnrichSuccessConfirmation = () => {
    const { intl } = this.props;
    const { showEnrichSuccessConfirmationBox } = this.state;

    return (
      <CustomModal
        modalTitleClassName="heading-04 text-uppercase"
        bodyClassName="text-capitalize-first"
        isOpen={(showEnrichSuccessConfirmationBox || false)}
        onClose={() => this._handleReset()}
        showCloseButton={true}
        modalTitle={intl.formatMessage({ "id": "enrich.success_modal.title", defaultMessage: "Enrich request submitted" })}
      >
        <div className="modal-body">
          <div className="text-center">
            <div className="d-flex flex-column justify-content-center gap-4">
              <p className="heading-04 fw-medium text-dark">
                <FormattedMessage id="enrich.success_modal.message_1" defaultmessage="The enrichment process has been initiated." /></p>
              <p className="heading-04 fw-medium text-dark">
                <FormattedMessage id="enrich.success_modal.message_2" defaultmessage="You will receive an email as soon as the process is completed." /></p>
            </div>
          </div>
        </div>

        <div className="modal-footer">
          <button type="button" className="btn btn-primary" onClick={() => this._handleReset()}>
            <FormattedMessage id="btn.close" defaultMessage="close" />
          </button>
        </div>
      </CustomModal>
    )
  }

  _renderAppendOptions = () => {
    const { totalRecords = 0 } = this.props;
    const { selectedAppendOption } = this.state;

    return (
      <div className="row gy-4 mt-0">
        <div className="col-lg-12">
          <div className="card shadow-none">
            <div className="card-body">
              <h6 className="heading-04 fw-semibold text-capitalize text-center">
                <FormattedMessage id="enrich.total_records" defaultMessage="Total Records: {totalRecords}" values={{ totalRecords: thousandSeparator(totalRecords) }} />
              </h6>
            </div>
          </div>
        </div>
        <div className="col-lg-12">
          <div className="card shadow-none">
            <div className="card-body">
              <h6 className="heading-04 fw-semibold mb-6 text-capitalize">
                <FormattedMessage id="enrich.append_options" defaultMessage="append options" />
              </h6>
              {!_isEmpty(this.appendOptionList) && (
                Object.values((this.appendOptionList || [])).map((value, key) => {
                  const isChecked = (selectedAppendOption === (value.id || "")) ? true : false;

                  return (
                    <div className="btn-group" role="group" aria-label="Append Options" key={`append-option-${key}`}>
                      <input
                        type="radio"
                        id={`append-options-${key}`}
                        className="btn-check"
                        name="selectedAppendOption"
                        value={(value.id || "")}
                        checked={(isChecked || false)}
                        disabled={(value.isDisabled || false)}
                        onChange={(e) => this.setState({ selectedAppendOption: (e.target.value || "") })}
                      />
                      <label className="btn btn-outline-primary text-capitalize" htmlFor={`append-options-${key}`}>
                        {(value.name || "")}
                      </label>
                    </div>
                  );
                })
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }

  _renderDataSources = () => {
    const { dataSourceList } = this.props;
    const { selectedSourcefield, defaultSearch } = this.state;

    return (

      <div className="row gy-4 mt-0">
        <div className="col-lg-12">
          <div className="card shadow-none">
            <div className="card-body">
              <h6 className="heading-04 fw-semibold mb-6 text-capitalize">
                <FormattedMessage id="enrich.data_source" defaultMessage="data source" />
              </h6>
              <div key="main-0">
                <DragDropContext onDragEnd={this._onDataSourceDragEnd}>
                  <Droppable droppableId="droppable">
                    {(provided) => (
                      <div
                        {...provided.droppableProps}
                        ref={provided.innerRef}
                      >
                        <Accordion className="accordion mb-8" defaultActiveKey={['accordion-0']} alwaysOpen>
                          {!_isEmpty(dataSourceList) && (
                            Object.values((dataSourceList || [])).map((v, key) => {
                              const existKey = this._checkInArray(v.id, selectedSourcefield);
                              const tmpSelectedIds = _map(_get(selectedSourcefield, `[${existKey}].data_fields`, []), "data_field_id");

                              let isDataSourceDisable = false;
                              if ((["Google", "Crunchbase"].includes(v.data_source_name || "")) && (defaultSearch !== "company")) {
                                isDataSourceDisable = true;
                              }

                              // Ensure we have a valid string ID for draggable
                              const draggableId = `item-${key}-${v.id || v.data_source_id || key}`;

                              return (
                                <Draggable key={draggableId} draggableId={draggableId} index={key}>
                                  {(provided) => (
                                    <div
                                      key={`item-drag-${key}`}
                                      ref={provided.innerRef}
                                      {...provided.draggableProps}
                                      {...provided.dragHandleProps}
                                    >
                                      <Card key={`card-${key}`}>
                                        <Accordion.Item eventKey={`accordion-${(key || 0)}`} >
                                          <Accordion.Button>
                                            <div className="form-check" onClick={(e) => e.stopPropagation()}>
                                              <input
                                                type="checkbox"
                                                id={`data_source-${v.id}`}
                                                className="form-check-input"
                                                name="data_source[]"
                                                value={(v.id || 0)}
                                                checked={(existKey !== false) ? true : false}
                                                disabled={(isDataSourceDisable || false)}
                                                onChange={(e) => {
                                                  e.stopPropagation();
                                                  this._handleDataSourceSelection(e.currentTarget.checked, v.id);
                                                }}
                                              />
                                              <label
                                                className="form-check-label text-black-2b ms-1"
                                                htmlFor={`data_source-${v.id}`}
                                                onClick={(e) => e.stopPropagation()}
                                              >
                                                {(v.data_source_name || "")}
                                              </label>
                                            </div>
                                          </Accordion.Button>
                                          <Accordion.Body>
                                            <div className="row gy-3">
                                              {!_isEmpty(v.data_field_group) && (
                                                Object.keys((v.data_field_group || [])).map((values, vk) => {
                                                  const groupName = _get(v, `data_field_group[${vk}].group_name`, "contact").toLowerCase();
                                                  const dataFields = _get(v, `data_field_group[${vk}].data_fields`, []);
                                                  const mandatoryColumns = []; //_get(v, `data_field_group[${vk}].mandatory_columns_for_data_upload`, []);

                                                  return (
                                                    <Fragment key={`data-fields-${key}-${vk}`}>
                                                      {!_isEmpty(v.data_field_group[vk]) && (
                                                        Object.values((dataFields || [])).map((vf, k) => {
                                                          let fieldValue = 0;
                                                          let tooltip = "";

                                                          if (defaultSearch === "contact") {
                                                            (vf.field_types || []).forEach(element => {
                                                              tooltip = (element.tooltip || "");

                                                              if (((groupName || "contact") === "common") && ((element.field_type_id || 0) === 1)) { // if field type 1 == contact
                                                                fieldValue = (element.data_field_id || 0);
                                                              } else if ((groupName || "contact") !== "common") {
                                                                fieldValue = (element.data_field_id || 0);
                                                              }
                                                            });
                                                          }

                                                          if (defaultSearch === "company") {
                                                            (vf.field_types || []).forEach(element => {
                                                              tooltip = (element.tooltip || "");

                                                              if ((defaultSearch === "company") && ((element.field_type_id || 0) === 2)) { // if field type 2 == Company
                                                                fieldValue = (element.data_field_id || 0);
                                                              }
                                                            });
                                                          }

                                                          let isFieldDisable = false;

                                                          if (
                                                            ((["Google", "Crunchbase"].includes(v.data_source_name || "")) && (defaultSearch !== "company")) ||
                                                            ((defaultSearch === "company") && groupName === "contact")
                                                          ) {
                                                            isFieldDisable = true;
                                                          }

                                                          return (
                                                            <div key={`field-${k}`} className="col-lg-2 col-md-4 col-sm-6">
                                                              <div className="form-check">
                                                                <input
                                                                  type="checkbox"
                                                                  id={`contact_field-${key}-${fieldValue}`}
                                                                  className="form-check-input"
                                                                  name="contact_field[]"
                                                                  value={(fieldValue || 0)}
                                                                  checked={((tmpSelectedIds).includes(fieldValue || null)) ? true : false}
                                                                  disabled={(isFieldDisable || false)}
                                                                  onChange={(e) => this._handleDataFieldSelection(e.currentTarget.checked, v.id, fieldValue, vf, groupName)}
                                                                />
                                                                <label className="form-check-label fw-normal text-black-2b ms-1" htmlFor={`contact_field-${key}-${fieldValue}`}>{(vf.field_name || "")}
                                                                  {!_isEmpty(tooltip) && (
                                                                    <OverlayTrigger
                                                                      overlay={(<Tooltip className="title title--smx tooltip-cls">{(tooltip || "")}</Tooltip>)}
                                                                      placement="top"
                                                                    >
                                                                      <i className="fa fa-info-circle ml-1" />
                                                                    </OverlayTrigger>
                                                                  )}
                                                                </label>
                                                              </div>
                                                            </div>
                                                          );
                                                        })
                                                      )}

                                                      {!_isEmpty(v.data_field_group[vk]) && (
                                                        Object.values((mandatoryColumns || [])).map((vf, k) => {
                                                          return (
                                                            <div key={`field-${k}`} className="col-lg-2 col-md-4 col-sm-6">
                                                              <div className="form-check">
                                                                <input
                                                                  type="checkbox"
                                                                  id={`contact_field-${key}-${vf.id}`}
                                                                  className="form-check-input"
                                                                  name="update_outcome_id"
                                                                  value={(vf.id || 0)}
                                                                  checked={((tmpSelectedIds).includes(vf.id || null)) ? true : false}
                                                                  onChange={(e) => this._handleDataFieldSelection(e.currentTarget.checked, v.id, vf.id, vf, groupName)}
                                                                  disabled={(defaultSearch !== groupName) ? true : false}
                                                                />
                                                                <label className="form-check-label fw-normal text-black-2b ms-1" htmlFor={`contact_field-${key}-${vf.id}`}>{(vf.field_name || "")}
                                                                  {!_isEmpty(vf.tooltip) && (
                                                                    <OverlayTrigger
                                                                      overlay={(<Tooltip className="title title--smx tooltip-cls">{vf.tooltip}</Tooltip>)}
                                                                      placement="top"
                                                                    >
                                                                      <i className="fa fa-info-circle ml-1" />
                                                                    </OverlayTrigger>
                                                                  )}
                                                                </label>
                                                              </div>
                                                            </div>
                                                          );
                                                        })
                                                      )}
                                                    </Fragment>
                                                  );
                                                })
                                              )}
                                            </div>
                                          </Accordion.Body>
                                        </Accordion.Item>
                                      </Card>
                                    </div>
                                  )}
                                </Draggable>
                              );
                            })
                          )}
                        </Accordion>
                        {(provided.placeholder || "")}
                      </div>
                    )}
                  </Droppable>
                </DragDropContext>
              </div>

              <div className="text-end">
                <button type="button" className="btn btn-primary waves-effect" onClick={() => this._handleSubmit(false)}>
                  <img src={require("../../../../assets/icons/icon-enrich.svg").default} className="img-fluid me-1" alt="" />
                  <FormattedMessage id="btn.enrich" defaultMessage="Enrich" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {

    return (
      <>
        {this._renderAppendOptions()}
        {this._renderDataSources()}

        {this._renderEnrichSuccessConfirmation()}
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  updatePageOperationLevelLoadingState: (data) => dispatch(updatePageOperationLevelLoadingState(data)),
});

export default connect(null, mapDispatchToProps)(withRouter(injectIntl(EnrichDataSources)));
